export default __webpack_public_path__ + "static/media/Bajaj1.3b16aeb7.jpg";